import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import sekolah from '../../images/sekolah.png';
import mapel from '../../images/mapel.png';
import materi from '../../images/materi.png';
import lms from '../../images/lms.png';
import calendar from '../../images/kalender.png';
import pengguna from '../../images/pengguna.png';
import pengumuman from '../../images/pengumuman.png';
import absensi from '../../images/absensi.png';
import bantuan from '../../images/bantuan.png';
import setting from '../../images/setting.png';
import dashboard from '../../images/dashboard-min.png';
import tagihan from '../../images/tagihan.png';

import axios from "../../axios";
import Alert from "react-s-alert";



class Sidebar extends Component {
	constructor() {
		super();

		this.state = {
			isLoading: false,
			kelas:[],
			mapel:[],
			thnAjar:false,
			times:'',
			tz:''
		};
	}

	loadData() {
		this.setState({ isLoading: true });

		axios({
			method: "post",
			url: "/dashboard"
		})
			.then(response => {
				const result = response.data;

				if (result.success) {
					this.setState({
						isLoading: false,
						kelas: result.data.kelas,
						mapel: result.data.mapel,
						thnAjar: result.data.thnAjar,
						times: result.data.times,
						tz: result.data.time.timezone,
					});

				} else {
					Alert.error(result.message);
					this.setState({ isLoading: false });
				}
			})
			.catch(error => {
				this.setState({ isLoading: false });
				Alert.error("Gagal terhubung ke server!");
			});
	}

	componentDidMount() {
		this.loadData();
	}

	handleClick(e) {
		e.preventDefault();
		e.target.parentElement.classList.toggle("open");
	}

	activeRoute(routeName) {
		return this.props.location.pathname.indexOf(routeName) > -1
			? "nav-item nav-dropdown open"
			: "nav-item nav-dropdown";
	}

	render() {
		return (
			<div className="sidebar">
				<nav className="sidebar-nav">
					{
						this.state.kelas.length > 0 &&
						this.state.mapel.length > 0 &&
						this.state.thnAjar ? (
							<ul className="nav">
								<li className="nav-item nav-dropdown">
									<NavLink
										to={"/dashboard"}
										className="nav-link"
										activeClassName="active"
									>
										<img src={dashboard} style={{width: "12%" }} />  Dashboard
									</NavLink>
								</li>

								{
									localStorage.SISMART_USER_LEVEL === 'administrator' ?
										(
											<li>
												{/* // <li className={this.activeRoute("/chat")}>
                                    //     <NavLink
                                    //         to={"/chat"}
                                    //         className="nav-link"
                                    //         activeClassName="active"
                                    //     >
                                    //         <i className="fa fa-comments" /> Chat
                                    //     </NavLink>
                                    // </li> */}

												<li className={this.activeRoute("/users")}>
													<a
														className="nav-link nav-dropdown-toggle"
														href=""
														onClick={this.handleClick.bind(this)}
													>
														<img src={pengguna} style={{width: "12%" }} />  Pengguna
													</a>
													<ul className="nav-dropdown-items">
														<li className="nav-item">
															<NavLink
																to={"/users"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Umum
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/users?l=siswa"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Siswa
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/users?l=wali"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Wali
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/users?l=guru"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Guru
															</NavLink>
														</li>
													</ul>
												</li>


												<li className={this.activeRoute("/exam")}>
													<a
														className="nav-link nav-dropdown-toggle"
														href=""
														onClick={this.handleClick.bind(this)}
													>
														<img src={lms} style={{width: "12%" }} />  LMS
													</a>
													<ul className="nav-dropdown-items">
														<li className="nav-item">
															<NavLink
																to={"/exam/category"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa " /> Kategori Ujian/Tugas
															</NavLink>
														</li>
														{/*<li className="nav-item">*/}
														{/*	<NavLink*/}
														{/*		to={"/exam/kartu-ujian"}*/}
														{/*		className="nav-link"*/}
														{/*		activeClassName="active"*/}
														{/*	>*/}
														{/*		<i className="fa " /> Kartu Ujian*/}
														{/*	</NavLink>*/}
														{/*</li>*/}
														<li className="nav-item">
															<NavLink
																to={"/exam/upload-rapor"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa " /> Upload Rapor File
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/exam/report"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Report Nilai
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/exam/pantau"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Pantau Ujian
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/exam/schedule"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Ujian/Tugas Online
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/tugas"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa " /> Tugas Offline
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/soal"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa " /> Bank Soal
															</NavLink>
														</li>
													</ul>
												</li>


												<li className={this.activeRoute("/iuran")}>
													<a className="nav-link nav-dropdown-toggle"
													   href=""
													   onClick={this.handleClick.bind(this)}
													><img src={tagihan} style={{width: "12%" }} /> Tagihan
													</a>
													<ul className="nav-dropdown-items">
														<li className="nav-item">
															<NavLink to={"/jenisiuran"}
																	 className="nav-link"
																	 activeClassName="active"
															>
																<i className="fa" />Jenis Tagihan
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/groupiuran"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" />Group Tagihan
															</NavLink>
														</li>

														<li className="nav-item">
															<NavLink
																to={"/masteriuran"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa " />Master Tagihan
															</NavLink>
														</li>

														{/* <li className="nav-item">
                                                <NavLink
                                                    to={"/diskoniuran"}
                                                    className="nav-link"
                                                    activeClassName="active"
                                                >
                                                <i className="fa " />Diskon Tagihan
                                                </NavLink>
                                            </li>  */}
														{/* <li className="nav-item">
                                                <NavLink
                                                    to={"/forwardiuran"}
                                                    className="nav-link"
                                                        activeClassName="active"
                                                    >
                                                <i className="fa " />Forward Tagihan
                                                </NavLink>
                                            </li>  */}
														<li className="nav-item">
															<NavLink
																to={"/iuransiswa"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa " />Tagihan Siswa
															</NavLink>
														</li>
													</ul>
												</li>

												<li className={this.activeRoute("/ebookvideo")}>
													<a
														className="nav-link nav-dropdown-toggle"
														href=""
														onClick={this.handleClick.bind(this)}
													>
														<img src={materi} style={{width: "12%" }} />  Materi
													</a>
													<ul className="nav-dropdown-items">
														<li className="nav-item">
															<NavLink
																to={"/materi"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Ebook
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/video"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Video
															</NavLink>
														</li>

													</ul>
												</li>


												<li className={this.activeRoute("/mapeljadwal")}>
													<a
														className="nav-link nav-dropdown-toggle"
														href=""
														onClick={this.handleClick.bind(this)}
													>
														<img src={mapel} style={{width: "12%" }} />  Mapel
													</a>
													<ul className="nav-dropdown-items">
														<li className="nav-item">
															<NavLink
																to={"/mapel"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Data Mapel
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/jadwal"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Jadwal Mapel
															</NavLink>
														</li>

													</ul>
												</li>

												<li className={this.activeRoute("/sekolah")}>
													<a
														className="nav-link nav-dropdown-toggle"
														href=""
														onClick={this.handleClick.bind(this)}
													>
														<img src={sekolah} style={{width: "12%" }} />  Sekolah
													</a>
													<ul className="nav-dropdown-items">
														<li className="nav-item">
															<NavLink
																to={"/kelas"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Data Kelas
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/naikkelas"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Mutasi Kelas
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/prestasi"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Prestasi
															</NavLink>
														</li>

														<li className="nav-item">
															<NavLink
																to={"/tahun_ajar"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Data Tahun Ajar
															</NavLink>
														</li>

													</ul>
												</li>

												<li className={this.activeRoute("/user-online")}>
													<a
														className="nav-link nav-dropdown-toggle"
														href=""
														onClick={this.handleClick.bind(this)}
													>
														<img src={absensi} style={{width: "12%" }} />  Laporan
													</a>
													<ul className="nav-dropdown-items">
														<li className="nav-item">
															<NavLink
																to={"/user-online"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> User Online
															</NavLink>
														</li>

													</ul>
												</li>


												<li className={this.activeRoute("/kalender")}>
													<a
														className="nav-link nav-dropdown-toggle"
														href=""
														onClick={this.handleClick.bind(this)}
													>
														<img src={calendar} style={{width: "12.2%" }} />  Kalender
													</a>
													<ul className="nav-dropdown-items">
														<li className="nav-item">
															<NavLink
																to={"/event"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Acara
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/libur"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Libur
															</NavLink>
														</li>


													</ul>
												</li>

												{/* // <li className={this.activeRoute("/tugas")}>
                                    //     <NavLink
                                    //         to={"/tugas"}
                                    //             className="nav-link"
                                    //             activeClassName="active"
                                    //         >
                                    //             <i className="fa fa-book" /> Tugas
                                    //     </NavLink>
                                    // </li>

                                    // <li className={this.activeRoute("/spp")}>
                                    //     <NavLink
                                    //         to={"/spp"}
                                    //         className="nav-link"
                                    //         activeClassName="active"
                                    //     >
                                    //         <i className="fa fa-bullhorn" /> Spp dan Pembayaran
                                    //     </NavLink>
                                    // </li> */}


												<li className={this.activeRoute("/announce")}>
													<a
														className="nav-link nav-dropdown-toggle"
														href=""
														onClick={this.handleClick.bind(this)}
													>
														<img src={pengumuman} style={{width: "12%" }} />  Pengumuman
													</a>
													<ul className="nav-dropdown-items">
														<li className="nav-item">
															<NavLink
																to={"/news"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Berita
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/pengumuman"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Pengumuman
															</NavLink>
														</li>


													</ul>
												</li>


												<li className={this.activeRoute("/reportpresensi")}>
													<a
														className="nav-link nav-dropdown-toggle"
														href=""
														onClick={this.handleClick.bind(this)}
													>
														<img src={absensi} style={{width: "12%" }} />  Rekap Absensi
													</a>
													<ul className="nav-dropdown-items">
														<li className="nav-item">
															<NavLink
																to={"/reportpresensi/nottaken"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Belum Absensi
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/reportpresensi/siswa"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Absensi Siswa
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/reportpresensi/guru"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Absensi Guru
															</NavLink>
														</li>
														<li className="nav-item">
															<NavLink
																to={"/reportpresensi/mapel"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> Absensi Kelas
															</NavLink>
														</li>
													</ul>
												</li>
												<li className={this.activeRoute("/arsip")}>
													<a
														className="nav-link nav-dropdown-toggle"
														href=""
														onClick={this.handleClick.bind(this)}
													>
														<img src={lms} style={{width: "12%" }} /> E-Document
													</a>
													<ul className="nav-dropdown-items">
														<li className={this.activeRoute("/arsip")}>
															<NavLink
																to={"/arsip/cat"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> E-Document Kategori
															</NavLink>
														</li>
														<li className={this.activeRoute("/arsip")}>
															<NavLink
																to={"/arsip"}
																className="nav-link"
																activeClassName="active"
															>
																<i className="fa" /> E-Document
															</NavLink>
														</li>
													</ul>
												</li>
												<li className={this.activeRoute("/help")}>
													<NavLink
														to={"/help"}
														className="nav-link"
														activeClassName="active"
													>
														<img src={bantuan} style={{width: "12%" }} />  Help & Feedback
													</NavLink>
												</li>

											</li>
										) : " "
								}


								{
									localStorage.SISMART_USER_LEVEL === 'administrator' ?
										(
											<li className={this.activeRoute("/informasi")}>
												<a
													className="nav-link nav-dropdown-toggle"
													href=""
													onClick={this.handleClick.bind(this)}
												>
													<img src={setting} style={{width: "12%" }} /> Pengaturan
												</a>
												<ul className="nav-dropdown-items">
													<li className={this.activeRoute("/setting")}>
														<NavLink
															to={"/setting"}
															className="nav-link"
															activeClassName="active"
														>
															<i className="fa" /> Umum
														</NavLink>
													</li>
													<li className={this.activeRoute("/shift")}>
														<NavLink
															to={"/shift"}
															className="nav-link"
															activeClassName="active"
														>
															<i className="fa" /> Waktu Absensi
														</NavLink>
													</li>
													{/*<li className={this.activeRoute("/setting/format-kartu")}>*/}
													{/*	<NavLink*/}
													{/*		to={"/setting/format-kartu"}*/}
													{/*		className="nav-link"*/}
													{/*		activeClassName="active"*/}
													{/*	>*/}
													{/*		<img src={setting} style={{width: "12%" }} /> Format Kartu Ujian*/}
													{/*	</NavLink>*/}
													{/*</li>*/}
												</ul>
											</li>
										) : " "
								}

								{/*<li className={this.activeRoute("/static-page")}>
							<NavLink
								to={"/static-page"}
								className="nav-link"
								activeClassName="active"
							>
								<i className="fa fa-file" /> Halaman Statis
							</NavLink>
						</li>*/}

								{/* <li className={this.activeRoute("/transaksi")}>
                            <a className="nav-link nav-dropdown-toggle" href="" onClick={this.handleClick.bind(this)}>
                                <i className="fa fa-money"></i> Transaksi
                            </a>
                            <ul className="nav-dropdown-items">
                                <li className="nav-item">
                                    <NavLink to={'/transaksi/add'} className="nav-link" activeClassName="active">
                                        <i className="fa fa-plus"></i> Transaksi Baru
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to={'/transaksi'} className="nav-link" activeClassName="active">
                                        <i className="icon-list"></i> Data Transaksi
                                    </NavLink>
                                </li>
                            </ul>
                        </li> */}
								{localStorage.SISMART_USER_LEVEL=='keuangan' ?
									(
										<li className={this.activeRoute("/iuran")}>
											<a className="nav-link nav-dropdown-toggle"
											   href=""
											   onClick={this.handleClick.bind(this)}
											><img src={tagihan} style={{width: "12%" }} /> Tagihan
											</a>
											<ul className="nav-dropdown-items">
												<li className="nav-item">
													<NavLink to={"/jenisiuran"}
															 className="nav-link"
															 activeClassName="active"
													>
														<i className="fa" />Jenis Tagihan
													</NavLink>
												</li>
												<li className="nav-item">
													<NavLink
														to={"/groupiuran"}
														className="nav-link"
														activeClassName="active"
													>
														<i className="fa" />Group Tagihan
													</NavLink>
												</li>

												<li className="nav-item">
													<NavLink
														to={"/masteriuran"}
														className="nav-link"
														activeClassName="active"
													>
														<i className="fa " />Master Tagihan
													</NavLink>
												</li>

												{/* <li className="nav-item">
                                            <NavLink
                                                to={"/diskoniuran"}
                                                className="nav-link"
                                                activeClassName="active"
                                            >
                                            <i className="fa " />Diskon Tagihan
                                            </NavLink>
                                        </li>  */}
												{/* <li className="nav-item">
                                            <NavLink
                                                to={"/forwardiuran"}
                                                className="nav-link"
                                                    activeClassName="active"
                                                >
                                            <i className="fa " />Forward Tagihan
                                            </NavLink>
                                        </li>  */}
												<li className="nav-item">
													<NavLink
														to={"/iuransiswa"}
														className="nav-link"
														activeClassName="active"
													>
														<i className="fa " />Tagihan Siswa
													</NavLink>
												</li>
											</ul>
										</li>
									)
									:""}

							</ul>
						):(
							<ul className="nav">
								<li className="nav-item nav-dropdown">
									<NavLink
										to={"/dashboard"}
										className="nav-link"
										activeClassName="active"
									>
										<img src={dashboard} style={{width: "12%" }} />  Dashboard
									</NavLink>
								</li>
							</ul>
						)
					}

                    
                    

				</nav>


            <div className="card-block">
				<strong>&copy;2017-2019</strong>
				<NavLink to="/">{" "}
					<strong>CMS-SISMART</strong>
				</NavLink><br></br>
				<span className="float-left">
				  <strong>Version</strong> {" "} 2.4.0
				</span>
				<span className="float-left">
				  <strong>{this.state.times}</strong> {" "+this.state.tz}
				</span>
            </div>

			</div>


		);
	}
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js